export default __webpack_public_path__ + "static/media/screen-monitor-green.7bc44f15.svg";